import { http } from 'http';

export default {
  getBBVAChallenge: guid => http.get(`/bconnect/token/${guid}`)
};
